export default __webpack_public_path__ + "static/media/salaa.1e1d5074.jpg";